module.exports = __webpack_public_path__ + "static/media/Eevee_gaussian2.65e87d8f.png";